<app-banner [heading]="'ART STUDIO'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
    <!-- ======= Features Section ======= -->
   <section id="features" class="features">
     <div class="container">

       <div class="row feature-item">
         <div class="col-lg-6">
           <img src="assets/img/studio/art/art1.jpg" class="img-fluid" alt="">
         </div>
         <div class="col-lg-6 pt-5 pt-lg-0">
           <h4></h4>
           <p>
             At Tagore Global School, the arts(fine arts,drama,music)has been an integrated part of the curriculum.
           We weave the arts into our core classroom curricula as well as teach specific artistic skills and abilities.
           Art instruction helps children with the development of motor skills,decision making,risk taking and inventiveness.
           Teaching through the arts can make even difficult concepts easy to understand.The school is well equipped with 
           the techniques that are necessary in presentations(visual, digital)that helps in connecting students with the outer world in a better way.
             
           </p>
                       <img src="assets/img/studio/art/art2.jpg" class="img-fluid" alt="">
         </div>
         
        
       </div> 

     </div>
   </section>
   <!-- End Features Section -->
   
   <!-- ======= About Section ======= -->
   <!-- End About Section --> 
 </main>